document.addEventListener("DOMContentLoaded", () => {
  const toggle = document.querySelector("[data-se-mobile-nav-toggle]");
  const panel = document.getElementById("se-mobile-nav-panel");

  if (!toggle || !panel) {
    return;
  }

  const setOpen = (open) => {
    toggle.setAttribute("aria-expanded", open ? "true" : "false");
    panel.hidden = !open;
    panel.classList.toggle("is-open", open);
  };

  setOpen(false);

  toggle.addEventListener("click", () => {
    const nextOpen = toggle.getAttribute("aria-expanded") != "true";
    setOpen(nextOpen);
  });

  document.addEventListener("click", (event) => {
    if (!panel.classList.contains("is-open")) {
      return;
    }

    const header = toggle.closest(".se-header");
    if (header && !header.contains(event.target)) {
      setOpen(false);
    }
  });

  window.addEventListener("resize", () => {
    if (window.innerWidth > 767) {
      setOpen(false);
    }
  });
});
